 /// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface ICRPLandingPage {
    }

    interface ICRPLandingPageScope extends ng.IScope {
        vm: CRPLandingPage;
    }

    interface Prospect {
        additionalData: any;
    }

    class CRPLandingPage implements ICRPLandingPage {
        static $inject: Array<string> = ["common", "Restangular", "$scope", "$location", "config"];
        static controllerId: string = "crpLandingPage";
        private log;
        firstName: string;
        middleName: string;
        crpOpen: boolean;
        transferPlanner: string;
        collegeSearch: string;
        cfncUrl: string;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ICRPLandingPageScope, private $location: ng.ILocationService,
            private config: IConfig) {
            this.log = common.logger.getLogFn(CRPLandingPage.controllerId);
            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, CRPLandingPage.controllerId)
                .then(() => {
                this.log("Activated CRP Landing Page");
                    this.crpOpen = this.checkDate();
                    this.cfncUrl = this.config.cfncUrl;
                    this.transferPlanner = this.config.umbracoUrl + "/plan-your-future/plan-for-college/transfer-student-planner/";
                    this.collegeSearch = this.config.cfncUrl + "/college-search"
            });
        }

        redirect() {
            this.$location.path('/collegeRedirection');
        }

        checkDate() {
            var currentDate = new Date();
            var year = currentDate.getFullYear();
            var openDate = new Date(year, 3);
            var closeDate = new Date(year, 8);
            if (currentDate >= openDate && currentDate < closeDate)
                return true;
            else return false;
        }
    }
    angular.module("app").controller(CRPLandingPage.controllerId, CRPLandingPage);
} 